"use client"
import { PageDrawerMobileRef } from "@/components/common/PageDrawerMobile"
import { Button, Col } from "antd"
import { forwardRef, useImperativeHandle, useRef } from "react"
import { useTranslation } from "react-i18next"
import InputAdult from "../desktop/InputAdult"
import InputChildren from "../desktop/InputChildren"
import InputInfant from "../desktop/InputInfant"
import PopupMobile, { PopupMobileRef } from "@/components/common/PopupMobile"


export type PopupSelectPassengerRef = {
  open: () => void,
  close: () => void,
}

type PopupSelectPassengerProps = {

}

const PopupSelectPassenger = forwardRef<PopupSelectPassengerRef, PopupSelectPassengerProps>(
  (props, ref) => {
    const refPopupMobile = useRef<PopupMobileRef>(null)
    const { t } = useTranslation()

    useImperativeHandle(ref, () => {
      return {
        open: () => refPopupMobile.current?.open(),
        close: () => refPopupMobile.current?.close()
      }
    }, [refPopupMobile.current])

    return (
      <PopupMobile
        headerProps={{
          title: t("flight.number_passengers"),
        }}
        ref={refPopupMobile}
        height={'34rem'}
      >
        <Col span={24}>
          <InputAdult />
          <InputChildren />
          <InputInfant />
        </Col>
        <Col span={24}>
          <Button onClick={() => refPopupMobile.current?.close()} type='primary' block size='large'>
            Xong
          </Button>
        </Col>
      </PopupMobile>
    )
  })

PopupSelectPassenger.displayName = 'PopupSelectPassenger'

export default PopupSelectPassenger